console.log('Fast Order Popup 2')
var shippings               = null;
var cashOnDiliveryPrice     = 0;
function checkUsers() {
    var valeur;
    var xhr = new XMLHttpRequest();
    var params = "name=" + Shopify.shop;
    var product = null;
    xhr.open('POST', 'https://fast.crodweb.com/api/store', true);

    var order_style = `
        .fast-order-sticky {
            position: fixed;
            bottom: 0;
            left: 0px;
            right: 0;
            box-shadow: 0px 1px 1px rgb(50, 50, 50, .75);
            background:  #FFFFFF;
            border-top: 2px solid #E7E7E7;
            z-index: 9;
        }
        .fast-order-sub-sticky {
            display: flex;
            justify-content: center;
            padding: 15px 0px;
        }
        .fast-order-sub-sticky .button-fast{
            height: 43px;
            font-size: 16px;
            border-radius: 0px;
            cursor: pointer;
            transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            line-height: 20px;
            user-select: none;
            text-align: center;
            border: 1px solid #0ba22a;
            font-weight: 400;
            outline: none;
            padding: 10px 55px;
            display: block;
            background: #0ba22a;
            color:  #FFFFFF;
            font-weight: 700;
        }
        .form-fast-order .noumidia-form-general h2 {
            line-height: 1em !important;
        }
        .sucess-order {
            display: block;
            font-size: 50px;
            justify-content: center;
            text-align: center;
            padding: 50px;
            line-height: 1.5em;
            color: green;
        }
        .noumidia-select {
            background: #c6c1c112;
            border: 1px solid #CAC8C8E8 !important;
            padding: 3px 0px 5px 60px !important;
            height: 48px;
            font-size: 14px;
            border-radius: 14px;
            transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            display: block;
            width: 100%;
            box-shadow: 0 1px 2px #fbfbfb0d !important;
            overflow: visible;
        }
        .noumidia-select option {
            color: #000;
            background-color: #fff;
            font-size: 15px;
            font-weight: 600;
            padding: 0px 0px;
        }
        #discount-fast-price {
            color: red !important;
        }
        .fast-none {
            display: none !important;
        }
        .label-fastorder {
            padding-left: 0px;
            color: #000;
            font-size: 14px;
            font-weight: 600;
        }
        .overlay-fast {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.7);
            transition: opacity 500ms;  
            visibility: hidden;
            opacity: 0;
            z-index: 99999;
            overflow-x: hidden;
            overflow-y: auto;
        }
        .overlay-fast:target {
            visibility: visible;
            opacity: 1;
        }
        .popup-fast {
            margin: 70px auto;
            padding: 20px;
            background: #fff;
            border-radius: 5px;
            width: 60%;
            position: relative;
            transition: all 2s ease-in-out;
            max-width: 500px;
        }
        .popup-fast .close {
            position: absolute;
            top: 4px;
            right: 5px;
            transition: all 200ms;
            font-size: 33px;
            font-weight: 500;
            text-decoration: none;
            color: #444;
            background: transparent;
            border-radius: 5px;
            width: 28px;
            height: 28px;
            border: none;
            cursor: pointer;
            line-height: 1px !important;
        }
        .popup-fast .close:hover {
            color: red;
        }
        .popup-fast .content {
            max-height: auto;
            overflow: auto;
        }
        .popup-head-product-fast {
            display: block;
            width: 100%;
            margin-top: 10px;
        }
        .popup-head-product-fast-list {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            justify-content: center;
            justify-items: center;
            border-top: 1px solid #c7c7c7;
            border-bottom: 1px solid #c7c7c7;
            padding: 10px 0px;
        }
        .popup-head-product-fast .img-product-fast {
            width: 17%;
            justify-content: left;
            justify-items: left;
            display: inline-flex;
            flex-wrap: wrap;
        }
        .popup-head-product-fast .price-title {
            width: 50%;
            justify-content: left;
            justify-items: left;
            display: inline-flex;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 700;
        }
        .popup-head-product-fast .title-product-fast {
            width: 83%;
            justify-content: left;
            justify-items: left;
            display: inline-flex;
            flex-wrap: wrap;
        }
        .popup-head-product-fast .price-price {
            width: 50%;
            justify-content: right;
            justify-items: right;
            display: inline-flex;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 700;
        }
        .popup-head-product-fast .img-product-fast .img-container-fast {
            width: 58px;
            overflow: hidden;
            height: 58px;
            justify-content: left;
            text-align: left;
            display: flex;
            padding-top: 0px;
        }
        .popup-head-product-fast .img-product-fast .img-container-fast img{
            width: 58px;
            height: 58px;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast {
            width: 90%;
            overflow: hidden;
            height: auto;
            justify-content: left;
            text-align: left;
            display: flex  !important;
            flex-wrap: wrap !important;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast h4 {
            display: -webkit-box;
            color: inherit;
            overflow: hidden;
            color: #000;
            -webkit-box-orient: vertical;
            font-weight: 600;
            font-size: .95em;
            line-height: 1.2;
            max-height: calc(1em * 1.2 * 2);
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0px;
            margin: 0px;
            width: 90%;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast span {
            font-size: 12px;
            font-weight: 900;
            color: #111;
            display: block;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast .price-fast {
            font-size: 13px;
            font-weight: 900;
            color: #111;
            justify-content: left;
            text-align: left;
            width: 100%;
            display: inline-flex !important;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast .price-fast span {
            font-size: 13px;
            font-weight: 900;
            color: #111;
            margin-left: 10px;
        }
        @media screen and (max-width: 992px) {
            .popup-fast {
                width: 80%;
            }
        }
        @media screen and (max-width: 600px) {
            .popup-fast {
                width: 94%;width: 94%;
            }
        }
        @media screen and (min-width: 1100px) {
            .popup-fast {
                width: 40%;
            }
        }
        .noumidia-form-general {
            border: 1px solid #0ba22a !important;
            border-radius: 7px !important;
            max-width: 445px !important;
        }
        #noumidia-save {
            background: #0ba22a !important;
            color: #FFFFFF  !important;
            border: 1px solid #0ba22a !important;
            border-radius: 7px !important;
            max-width: 445px;
            display: block;
            height: 54px !important;
        }
        .btn-noumidia {
            height: 52px !important;
        }
        #noumidia-save:hover {
            box-shadow: none !important;
        }

        #noumidia-send {
            background: #0ba22a !important;
            color: #FFFFFF  !important;
            border: 1px solid #0ba22a !important;
            border-radius: 7px !important;
            font-size: 14pxpx !important;
            max-width: 465px;
        }
        .noumidia-form-general {
            background: #FFFFFF !important;
            border: 1px solid #0ba22a !important;
            border-radius: 7px !important;
        }
        .noumidia-form-general h2 {
            color: #0ba22a  !important;
            font-size: 14px !important;
        }
        .form-fast-order {
            display: block;
            width: 100%;
            flex: 0 0 100%;
        }
        .form-fast-order svg {
            fill: #0ba22a;
            color: #FFFFFF;
        }
        .popup-head-product-fast .img-product-fast .img-container-fast img {
            border-radius: 8px !important;
            overflow:hidden;
        }

        .qty-input-fast {
            color: #000;
            background: #fff;
            display: flex;
            align-items: center;
            overflow: hidden;
            justify-content: center;
            height: 40px;
            margin-bottom: 15px;
            margin-top: 15px;
        }
       
       .qty-input-fast .product-qty, .qty-input-fast .qty-count-fastorder {
            background: transparent;
            color: #444444;
            font-weight: bold;
            font-size: inherit;
            border: none;
            display: inline-block;
            min-width: 0;
            height: 3.5rem !important;
            line-height: 1;
            box-shadow: none;
            margin: 0px !important;
        }
       
       .qty-input-fast .product-qty:focus, .qty-input-fast .qty-count-fastorder:focus {
            outline: none;
        }
       
       .qty-input-fast .product-qty {
            width: 100%;
            min-width: 0;
            display: inline-block;
            text-align: center;
            appearance: textfield;
        }
       
       .qty-input-fast .product-qty::-webkit-outer-spin-button, .qty-input-fast .product-qty::-webkit-inner-spin-button {
            appearance: none;
            margin: 0;
        }
       
       .qty-input-fast .qty-count-fastorder {
            padding: 0;
            cursor: pointer;
            width: 55px;
            font-size: 1.25em;
            text-indent: -100px;
            overflow: hidden;
            position: relative;
            height: 100%;
            background: #dad2d2;
            border: 1px solid #e1d2d2; 
            border-radius: 7px;
        }
       
       .qty-input-fast .qty-count-fastorder:before, .qty-input-fast .qty-count-fastorder:after {
            content: "";
            height: 2px;
            width: 10px;
            position: absolute;
            display: block;
            background: #000;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
        }
       
       .qty-input-fast .qty-count--add-fastorder:after {
            transform: rotate(90deg);
        }
       
       .qty-input-fast .qty-count-fastorder:disabled {
            color: #ccc;
            background: #f2f2f2;
            cursor: not-allowed;
            border-color: transparent;
        }
       
       .qty-input-fast .qty-count-fastorder:disabled:before, .qty-input-fast .qty-count-fastorder:disabled:after {
            background: #ccc;
        }
       
       .qty-input-fast {
            border-radius: 4px;
        }

        .btn-shadow {
            box-shadow: 9px 12px 22px -6px rgba(0, 0, 0, 0.4);
            cursor: pointer;
        }

        .btn-animation {
            animation: glow 3s infinite ;
        }

        .btn-animation:hover {
            transform: translate(0, 0) !important;
        }
        
        @keyframes glow{
            0%{
                transform: translate(0, 0);
                -webkit-transform: translate(0, 0);
            }
            
            2.0979% {
                transform: translate(10px, 0);
                -webkit-transform: translate(10px, 0);
            }

            4.1958% {
                transform: translate(-10px, 0);
                -webkit-transform: translate(0, 0);
            }

            6.29371% {
                transform: translate(10px, 0);
                -webkit-transform: translate(10px, 0);
            }

            8.39161% {
                transform: translate(-10px, 0);
                -webkit-transform: translate(0, 0);
            }

            10.4895% {
                transform: translate(10px, 0);
                -webkit-transform: translate(10px, 0);
            }

            12.5874% {
                transform: translate(-10px, 0);
                -webkit-transform: translate(0, 0);
            }

            100% {
                transform: translate(0, 0);
                -webkit-transform: translate(0, 0);
            }

        }
  
        body.modal-open-fast {
            overflow: hidden;
        }

        .noumidia-form-group{
            font-size: 14px !important;
            color: #777 !important;
            margin-bottom: 15px !important;
            position: relative !important;
            margin-top: 0px !important;
        }

        .noumidia-form-group .span-error{
            color: red;
            font-size: 10px;
            display: block;
            width: 100%;
            display: none;
        }

        .span-phone-error {
            color: red;
            font-size: 10px;
            display: block;
            width: 100%;
            display: none; 
        }

        .noumidia-form-group::after {
            height: 34px !important;
            left: 0px !important;
            top: 7px !important;
            border-right: 1px solid #CAC8C8E8 !important;
            background: #e6e3e312 !important;
        }

        .noumidia-input {
            background: #c6c1c112 !important;
            box-shadow: 0 1px 2px #fbfbfb0d !important;
            border-radius: 5px !important;
            border: 1px solid #CAC8C8E8 !important;
        }

        .lds-ring {
            display: inline-block;
            position: relative;
            width: 25px;
            height: 25px;
            display: none;
        }

        .lds-ring div {
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 21px;
            height: 21px;
            margin: 8px;
            border: 3px solid #fff;
            border-radius: 50%;
            animation: lds-ring 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            border-color: #fff transparent transparent transparent;
            display: flex;
        }

        .lds-ring div:nth-child(1) {
            animation-delay: -0.45s;
        }

        .lds-ring div:nth-child(2) {
            animation-delay: -0.3s;
        }

        .lds-ring div:nth-child(3) {
            animation-delay: -0.15s;
        }

        @keyframes lds-ring {
            0% {
            transform: rotate(0deg);
            }
            100% {
            transform: rotate(360deg);
            }
        }
        /* *************************************** */
        /* *************************************** */
        /* *************************************** */
        .discount-radio:checked,
        .discount-radio:not(:checked) {
            position: absolute;
            // left: -9999px;
            visibility: hidden;
        }
        .discount-radio:checked + label,
        .discount-radio:not(:checked) + label
        {
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            line-height: 24px;
            display: inline-block;
            color: #444;
            font-weight: 600;
            font-size: .92em;
        }
        .discount-radio:checked + label:before,
        .discount-radio:not(:checked) + label:before {
            content: '';
            position: absolute;
            left: 0px;
            top: 5px;
            width: 20px;
            height: 20px;
            border: 1px solid #ddd;
            border-radius: 100%;
            background: #fff;
            margin-top: 13px;
            margin-left: 10px;
        }
        .discount-radio:checked + label:after,
        .discount-radio:not(:checked) + label:after {
            content: '';
            width: 12px;
            height: 12px;
            background: #F87DA9;
            position: absolute;
            top: 9px;
            left: 4px;
            border-radius: 100%;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
            margin-top: 13px;
            margin-left: 10px;
        }
        .discount-radio:not(:checked) + label:after {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        .discount-radio:checked + label:after {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1);
        }
        .discounts-details label {
            background: #FFF;
            width: 100%;
            margin: 5px 0px;
            padding: 15px 25px !important;
            border-radius: 10px;
            box-shadow: 3px 3px 7px -13px rgba(0, 0, 0, 0.9);
            border: 2px solid #CAC8C8E8 !important;
        }
        .discounts-details p {
            padding: 0px !important;
            margin: 0px !important;
        }
        .facture-price {
            background: #f9f9f9;
            padding: 15px 15px !important;
            border-radius: 5px !important;
            margin-bottom: 10px;
            color: #000;
            background-color: #f9f9f9;
            border: 1px solid #d3d3d3;
        }
        html:lang(ar) .discounts-details p {
            direction: rtl;
        }
        html:lang(ar) .label-fastorder {
            text-align: right;
            display: block;
        }
        html:lang(ar) .facture-price {
            direction: rtl;
        }
        html:lang(ar) .facture-price .price .fast-title {
            text-align: right;
        }
        html:lang(ar) .facture-price .price .fast-price {
            text-align: right;
        }
        .facture-price .price{
            display: flex;
            width: 100%;
            padding: 0px !important;
            margin: 0px !important;            
            flex-direction: initial !important;
        }
        .facture-price .price .fast-title {
            font-size: 14px;
            font-weight: 400;
            font-style: normal;
            width: 50%;
            text-align: left;
            color: #000;
        }
        .facture-price .price .fast-price {
            font-size: 15px;
            font-weight: 700;
            font-style: normal;
            width: 50%;
            text-align: right;
            color: #33333;
        }
        .total_price {
            border-top: 1px solid hsla(0,0%,68.6%,.34)!important;
            margin: 5px 0px 0px !important;
            padding: 5px 0px 0px !important;
        }
        .total_price.price .fast-title {
            font-size: 16px !important;
            font-weight: 700 !important;
        }
        .total_price.price .fast-price {
            font-size: 16px !important;
            font-weight: 700 !important;
        }
        /* *************************************** */
        /* *************************************** */
        /* *************************************** */
        .shipping-radio:checked,
        .shipping-radio:not(:checked) {
            position: absolute;
            // left: -9999px;
            visibility: hidden;
        }
        .shipping-radio:checked + label,
        .shipping-radio:not(:checked) + label
        {
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            line-height: 20px;
            display: flex;
            color: #666;
        }
        .shipping-radio:checked + label:before,
        .shipping-radio:not(:checked) + label:before {
            content: '';
            position: absolute;
            left: 0px;
            top: 0px;
            width: 20px;
            height: 20px;
            border: 1px solid #ddd;
            border-radius: 100%;
            background: #fff;
            margin-top: 13px;
            margin-left: 10px;
        }
        .shipping-radio:checked + label:after,
        .shipping-radio:not(:checked) + label:after {
            content: '';
            width: 12px;
            height: 12px;
            background: #F87DA9;
            position: absolute;
            top: 4px;
            left: 4px;
            border-radius: 100%;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
            margin-top: 13px;
            margin-left: 10px;
        }
        .shipping-radio:not(:checked) + label:after {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        .shipping-radio:checked + label:after {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1);
        }
        .shippings-details label {
            background: #FFF;
            width: 100%;
            padding: 13px 45px !important;
            border-radius: 10px;
            box-shadow: 3px 3px 7px -13px rgba(0, 0, 0, 0.9);
        }
        .shippings-details p {
            padding: 0px !important;
            margin: 0px !important;
        }
        .shippings-details label .shipping-title {
            text-align: left;
            flex: 0 0 50%;
        }
        .shippings-details label .shipping-price {
            text-align: right;
            flex: 0 0 50%;
        }
        html:lang(ar) .shippings-details label .shipping-title {
            text-align: right;
        }
        html:lang(ar) .shippings-details label .shipping-price {
            text-align: left;
        }
        html:lang(ar) .shippings-details label { 
            direction: rtl;
        }
    `;

    var order_form = `
        <div id="popup-fast-1" class="overlay-fast">
            <div id="popup-fast" class="popup-fast">
                <div id="popup-head-product-fast" class="popup-head-product-fast">
                    <div class="popup-head-product-fast-list">
                    </div>
                </div>
                <button type="button" class="close" id="close" onclick="closePopup()" >&times;</button>
                <div class="content">
                    <input type="hidden" id="fast_product_id" name="fast_product_id" value="" class="fast_product_id">
                    <div class="form-fast-order">
                        <div id="form-fast" class="form-fast">
                                <div class="noumidia-form-general">
                                    <h2>Fast Order</h2>
                                    <div id="form-fast-input" class="form-fast-input">
                                    <input type="radio" id="sale-fast" name="sale-fast" value="qty" class="discount-radio">
            <p class="discounts-details" id="discounts-details"></p><p class="shippings-details" id="shippings-details"></p><div class="qty-input-fast">
                    <button class="qty-count qty-count-fastorder" data-action="minus" type="button"  onclick="minusQty()">-</button>
                    <input class="product-qty" type="number" name="product-qty" id="fast-product-qty" min="0" max="10" value="1" disabled>
                    <button class="qty-count qty-count-fastorder qty-count--add-fastorder"  data-action="add" type="button"  onclick="addQty()">+</button>
                </div>
                    <p class="noumidia-form-group">
                        <input placeholder="Last Name"   type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="last_name" id="last_name" value="">							
                        <span id="span-last_name" class="span-error">This field is required</span>
                        
                        
                        <label for="last_name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </label> 
                    </p>
                
                    <p class="noumidia-form-group">
                        <input placeholder="First Name"   type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="first_name" id="first_name" value="">							
                        <span id="span-first_name" class="span-error">This field is required</span>
                        
                        
                        <label for="first_name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </label> 
                    </p>
                
                    <p class="noumidia-form-group">
                        <input placeholder="Phone" onblur="customerAbandoned()"  type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="phone" id="phone" value="">							
                        <span id="span-phone" class="span-error">This field is required</span>
                        <span id="span-phone-error"  class="span-error">Format phone invalide</span>
                        
                        <label for="phone">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        </label> 
                    </p>
                
                    <p class="noumidia-form-group">
                        <input placeholder="Address"   type="text"  class="noumidia-input noumidia-form-control"  name="address" id="address" value="">							
                        <span id="span-address" class="span-error">This field is required</span>
                        
                        
                        <label for="address">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                        </label> 
                    </p>
                
                    <p class="noumidia-form-group">
                        <input placeholder="city"   type="text"  class="noumidia-input noumidia-form-control"  name="city" id="city" value="">							
                        <span id="span-city" class="span-error">This field is required</span>
                        
                        
                        <label for="city">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                        </label> 
                    </p>
                
                <div class="facture-price">
                    
                    <p class="price product_price">
                        <span class="fast-title"> SubTotal </span>
                        <span id="product-fast-price" class="product-fast-price fast-price"> </span>
                    </p>
                    <p class="price discount_price fast-none" id="discount_price">
                        <span class="fast-title"> Discount </span>
                        <span id="discount-fast-price" class="discount-fast-price fast-price"> </span>
                    </p>
                    <p class="price total_price">
                        <span class="fast-title"> Total </span>
                        <span id="fast-price" class="fast-price"> </span>
                    </p>
                </div> 
            
                                    </div>
                                    <p class="noumidia-form-group-btn">	
                                        <span id="error-message-cod-popup" class="error-message-cod"></span>
                                        <button type="button" class="btn btn-noumidia noumidia-save" id="noumidia-send" name="register" onclick="addTodo()">				
                                            <div id="lds-ring" class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                            <span id="text-span">Buy Now With Cash On Delivery</span>
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
        </div>
        <style>
        ${order_style}
        </style>
    `;
    // http://svgicons.sparkk.fr/
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
            valeur = JSON.parse(xhr.response);
            if (valeur.status == 0) {
          
            } else {
                if( valeur.cod ) {
                    shippings = valeur.cod;
                }
                var id_form = null;       
                // var parentDiv = document.getElementsByClassName("form-fast-popup");                  
                var parentDiv = document.getElementById("form-fast-popup");
                var popup_fast_order = document.getElementById("popup-fast-order");
                if(typeof parentDiv != null && parentDiv !== null  ) {
                    if(typeof popup_fast_order != null && popup_fast_order !== null  ) {
                        popup_fast_order.style.display = "block";
                    }
                    var entrer = false;
                    parentDiv.innerHTML = order_form;
                    let product_id = document.getElementById("fast_product_id");
                    if(typeof product_id !== null  && product_id !== null  ) {
                        product_id = product_id.value;
                        detaile_products(product_id);
                    }
                } else {
                    console.log("Please Reload Page")  
                }
                
                const elp = document.getElementById("noumidia-save");
                if(typeof elp != null && elp !== null  ) {
                    let box_shadow = true;
                    if(box_shadow) {
                        elp.classList.add("btn-shadow");
                    }
                    let button_animation = true;
                    if(button_animation) {
                        elp.classList.add("btn-animation");
                    }
                }
            }
        }
    }
    xhr.send(params);
}
document.addEventListener('DOMContentLoaded', function() {
    checkUsers();
}, false);
function shipping_details(id_product) {
    // shippings-details
    var html = '';
    if(Array.isArray( shippings)) {
        shippings.forEach((element, index) => {
            element['rates'].forEach((rate, i) => {
                let status = '';
                if( i == 0 ) {
                    status = '';
                }
                html += `
                    <p>
                        <input type="radio" id="shipping-${rate.id_rate}" ${status} data-price="${rate.price}" name="shipping-product" value="${rate.id_rate}" onclick="checkRadioShipping(${rate.id_rate})" class="shipping-radio">
                        <label for="shipping-${rate.id_rate}">
                            <span class="shipping-title"> ${rate.title} </span>
                            <span class="shipping-price"> ${rate.price} </span>
                        </label>
                    </p>
                `;
            });
        });
        let shippings_details = document.getElementById("shippings-details");
        if(typeof shippings_details !== null  && shippings_details !== null  ) {
            shippings_details.innerHTML = html;
        } 
    }

};
function detaile_products(product_id) {
    var crossel = new XMLHttpRequest();
    product = meta.product;
    product_id = product.id; 
    shipping_details(product.id);
    // START GET DISCOUNTS
    var params = "name=" + Shopify.shop+"&product_id=" + product_id;
    crossel.open('POST', 'https://fast.crodweb.com/api/details', true); 
    crossel.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    crossel.onreadystatechange = function () {
        if (crossel.readyState == 4 && crossel.status == 200) {
            let discount = JSON.parse(crossel.response);
            let html = '';
            if(Array.isArray( discount['discount'])) {
                discount['discount'].forEach((element, index) => {
                    let status = '';
                    if( index == 0 ) {
                        status = 'checked';
                    }
                    html += `
                        <p>
                            <input type="radio" id="discount-${element.id_discount}" ${status} data-type="${element.discount_type}" data-valeur="${element.value}" data-qty="${element.qty}" name="crossel-product" value="${element.id_discount}" onclick="checkRadio(${element.id_discount})" class="discount-radio">
                            <label for="discount-${element.id_discount}">${element.description}</label>
                        </p>
                    `;
                });
            }
            let discounts_details = document.getElementById("discounts-details");
            if(typeof discounts_details !== null  && discounts_details !== null  ) {
                discounts_details.innerHTML = html;
            } 
            let sale_fast = document.getElementById("sale-fast");
            if(typeof sale_fast !== null  && sale_fast !== null  ) {
                if( discount != null ) {
                    const result2 = discount['discount']?.length || 0;
                    if( result2 > 0 ) {
                        sale_fast.value = "discount";
                        let qty_input = document.getElementsByClassName("qty-input-fast")[0];
                        if(typeof qty_input !== null  && qty_input !== null  ) {
                            qty_input.style.display = "none";
                        } 
                    }                            
                }                           
            } 
        }
    }
    crossel.send(params);
    // END DISSCOUNT
    let id_variant = document.getElementsByName("id");
    if(product.variants != null) {
        product.variants.forEach((element, index) => {
            if(typeof id_variant !== null  && id_variant !== null) {
                if(element.id == id_variant[0].value ) {
                    let fast_price = document.getElementById("fast-price");
                    if(typeof fast_price !== null  && fast_price !== null) {
                        fast_price.innerHTML = ((parseFloat(element.price/100)+parseFloat(cashOnDiliveryPrice)).toFixed(2)) +" "+Shopify.currency.active;
                        fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                        fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                    }
                    let product_fast_price = document.getElementById("product-fast-price");
                    if(typeof product_fast_price !== null  && product_fast_price !== null) {
                        product_fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                        product_fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                        product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                    }
                }
            }   
        });
    } else {
        let fast_price = document.getElementById("fast-price");
        if(typeof fast_price !== null  && fast_price !== null) {
            fast_price.innerHTML = ((parseFloat(product.price/100)+parseFloat(cashOnDiliveryPrice)).toFixed(2)) +" "+Shopify.currency.active;
            fast_price.setAttribute('data-price' , product.price/100); 
            fast_price.setAttribute('data-currency' , Shopify.currency.active); 
        }
        let product_fast_price = document.getElementById("product-fast-price");
        if(typeof product_fast_price !== null  && product_fast_price !== null) {
            product_fast_price.innerHTML = parseFloat(product.price/100).toFixed(2) +" "+Shopify.currency.active;
            product_fast_price.setAttribute('data-price' , product.price/100); 
            product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
        }
    }
}
// VALIDATION NUMBER PHONE
function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
}
// =======================================================
//  POST to cart/add.js returns the JSON of the line item.
// =======================================================
Shopify.addItemFrom = function (variant_id, quantity, callback) {
    return new Promise(resolve => {
        var xhrAb = new XMLHttpRequest();
        var params = "quantity=" + quantity + "&id=" + variant_id;
        xhrAb.open('POST', '/cart/add.js', true);
        xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrAb.onreadystatechange = function () {
            if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                valeur = JSON.parse(xhrAb.response);
                resolve( valeur );
            }
        }
        xhrAb.send(params);
    });
};

Shopify.change = function (variant_id, quantity, callback) {
    return new Promise(resolve => {
        var xhrAb = new XMLHttpRequest();
        var params = "quantity=" + quantity + "&id=" + variant_id;
        xhrAb.open('POST', '/cart/change.js', true);
        xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrAb.onreadystatechange = function () {
            if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                valeur = JSON.parse(xhrAb.response);
                resolve(valeur);
            }
        }
        xhrAb.send(params);
    });
};

Shopify.clear = function () {
    return new Promise(resolve => {
        let xhrClear = new XMLHttpRequest();
        xhrClear.open('POST', '/cart/clear.js', true);
        xhrClear.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrClear.onreadystatechange = function () {
            valeur =xhrClear.response;
            resolve( valeur );
        }
        xhrClear.send();
    });
};

Shopify.getProductByHandle = function (handle) {
    return new Promise(resolve => {
        var xhrAb = new XMLHttpRequest();
        xhrAb.open('GET', "/products/" + handle + ".js", true);
        xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrAb.onreadystatechange = function () {
            if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                valeur = JSON.parse(xhrAb.response);
                resolve(valeur);
            }
        }
        xhrAb.send();
    });
};

function getProductInCart(id_variant) {
    return new Promise(resolve => {
        var xhrAb = new XMLHttpRequest();
        var item;
        xhrAb.open('GET', "/cart.js", true);

        xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrAb.onreadystatechange = async function () {
            if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                valeur = JSON.parse(xhrAb.response);
                valeur['items'].forEach(element => {
                    if (parseInt(element['id']) == parseInt(id_variant)) {
                        item = element['id'];
                        resolve(element);
                    }
                });
            }
        }
        xhrAb.send();
    });
};
// Required Message Validation
function requiredMessage(input) {
    var msg_error = document.getElementById("span-"+input);
    if(typeof msg_error != null && msg_error !== null  ) {
        var input = document.getElementById(input);
        if(typeof input != null && input !== null  ) {
            var req = input.getAttribute('data-req');
            if( req == "1" && input.value == "" ) {
                input.style.border = "1px solid red";
                msg_error.style.display = 'block';
                return true;
            } else {
                input.style.border = "1px solid #F0ECECE8";
                msg_error.style.display = 'none';
                return false;
            }
        }
    }
};
function getAllProductInCart() {
    return new Promise(resolve => {
        var xhrAb = new XMLHttpRequest();
        var item;
        xhrAb.open('GET', "/cart.js", true);
        xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrAb.onreadystatechange = async function () {
            if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                valeur = JSON.parse(xhrAb.response);
                // valeur['items'].forEach(element => {
                    resolve(valeur['items']);
                // });
            }
        }
        xhrAb.send();
    });
};
// =======================================================
// ============ SET AND GET COOKIES ======================
// =======================================================
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
// CLICK BUTTON OPEN POPUP
async function openPopup() {
    let body = document.getElementsByTagName('body')[0];
    if(typeof body != null && body !== null  ) {
        body.classList.add("modal-open-fast");
    }
    // let sticky = document.getElementsByTagName('sticky-header')[0];
    // if(typeof sticky != null && sticky !== null  ) {
    //     sticky.style.display = 'none';
    // }
    let popup_fast_1 = document.getElementById("popup-fast-1");
    let popup_fast   = document.getElementById("popup-fast");
    let head_product   = document.getElementById("popup-head-product-fast");
    popup_fast_1.style.visibility = 'visible';
    popup_fast_1.style.opacity    = 1;
    popup_fast.style.visibility   = 'visible';
    await Shopify.clear(); 
    let id_variant = document.getElementsByName("id");
    console.log("id_variant")
    console.log(id_variant[0].value)
    await Shopify.addItemFrom( id_variant[0].value , 1, 0);
    let items_cart = await getAllProductInCart();
    let html = '';
    html = await htmlListProduct(valeur['items']);
    head_product.innerHTML = html;
}
// CLICK BUTTON OPEN POPUP
async function addQty() {
    let product_qty = document.getElementById("fast-product-qty");
    if(typeof product_qty != null && product_qty !== null  ) {
        let max = product_qty.getAttribute('max');
        if( parseInt(product_qty.value) < parseInt(max) ) {
            product_qty.value = parseInt(product_qty.value) + 1;
            let id_variant = document.getElementsByName("id");
            await Shopify.change( id_variant[0].value , product_qty.value, 0);
            let items_cart = await getAllProductInCart();
            let html = '';
            html = await htmlListProduct(valeur['items']);
            let head_product   = document.getElementById("popup-head-product-fast");
            head_product.innerHTML = html;
            let fast_price = document.getElementById("fast-price");
            if(typeof fast_price !== null  && fast_price !== null) {
                let price_unit = fast_price.getAttribute('data-price');
                if(typeof price_unit !== null  && price_unit !== null) { 
                    fast_price.innerHTML = (((parseFloat(price_unit)*product_qty.value)+parseFloat(cashOnDiliveryPrice)).toFixed(2)) +" "+Shopify.currency.active;
                }
                let product_fast_price = document.getElementById("product-fast-price");
                if(typeof product_fast_price !== null  && product_fast_price !== null) {
                    product_fast_price.innerHTML =  (parseFloat(price_unit)*product_qty.value).toFixed(2) +" "+Shopify.currency.active;
                }
            }
        }
    }
}
// CLICK BUTTON OPEN POPUP
async function minusQty() {
    let product_qty = document.getElementById("fast-product-qty");
    if(typeof product_qty != null && product_qty !== null  ) {
        let min = product_qty.getAttribute('min');
        if( parseInt(product_qty.value) > parseInt(min) ) {
            if( parseInt(product_qty.value) > 1 ) {
                product_qty.value = parseInt(product_qty.value) -1;
                let id_variant = document.getElementsByName("id");
                await Shopify.change( id_variant[0].value , product_qty.value, 0);
                let items_cart = await getAllProductInCart();
                let html = '';
                html = await htmlListProduct(valeur['items']);
                let head_product   = document.getElementById("popup-head-product-fast");
                head_product.innerHTML = html;
                let fast_price = document.getElementById("fast-price");
                if(typeof fast_price !== null  && fast_price !== null) {
                    let price_unit = fast_price.getAttribute('data-price');
                    if(typeof price_unit !== null  && price_unit !== null) { 
                        fast_price.innerHTML = (((parseFloat(price_unit)*product_qty.value)+parseFloat(cashOnDiliveryPrice)).toFixed(2)) +" "+Shopify.currency.active;
                    } 
                    let product_fast_price = document.getElementById("product-fast-price");
                    if(typeof product_fast_price !== null  && product_fast_price !== null) {
                        product_fast_price.innerHTML =  (parseFloat(price_unit)*product_qty.value).toFixed(2) +" "+Shopify.currency.active;
                    }
                }
            }
        }
    }
}
// CLICK BUTTON OPEN POPUP
async function closePopup() {
    let body = document.getElementsByTagName('body')[0];
    if(typeof body != null && body !== null  ) {
        body.classList.remove("modal-open-fast");
    }
    // let sticky = document.getElementsByTagName('sticky-header')[0];
    // if(typeof sticky != null && sticky !== null  ) {
    //     sticky.style.display = 'block';
    // }
    await Shopify.clear(); 
    let popup_fast_1 = document.getElementById("popup-fast-1");
    let popup_fast   = document.getElementById("popup-fast");
    let head_product   = document.getElementById("popup-head-product-fast");
    popup_fast_1.style.visibility = 'hidden';
    popup_fast_1.style.opacity    = 0;
    popup_fast.style.visibility   = 'hidden';
    
}
async function htmlListProduct(items) {
    return new Promise(resolve => {
        let html = '';
        let price = 0;
        items.forEach(async element => {
            let variants = '';
            element['options_with_values'].forEach(async (variant, index) => {
                if( index != 0 ) {
                    variants += ' / ';
                }
                variants +=  variant.name +' : '+ variant.value;
            });
            price += (element['line_price'])/100;
            html += `
                <div class="popup-head-product-fast-list">
                    <div class="img-product-fast">
                        <div class="img-container-fast">
                            <img src="${element['image']}">
                        </div> 
                    </div>
                    <div class="title-product-fast">
                        <div class="title-container-fast">
                            <h4 class="title-h4-fast"> 
                                ${element['title']}
                            </h4> 
                            <span>
                            ${ variants }
                            </span> 
                            <span class="price-fast"> 
                                Price: 
                                <span>  ${element['quantity']} X ${element['price']/100} ${Shopify.currency.active} </span> 
                            </span> 
                        </div> 
                    </div>
                </div>
            `;          
        });
        html += `
            <div style="display: none !important;" class="popup-head-product-fast-list">
                <div class="price-title">
                    <span class="price-title"> Total </span>
                </div>
                <div class="price-price">
                    <span class="price-price"> ${price} ${Shopify.currency.active} </span>
                </div>
            </div>
        `;  
        resolve(html);
    });
}
// CLICK BUTTON SEND ORDER
async function addTodo() {
    document.getElementById("noumidia-send").disabled = true;
    // VALIDATION
    let req_last    = await requiredMessage("last_name");
    let req_first   = await requiredMessage("first_name");
    let req_phone   = await requiredMessage("phone");
    let req_address = await requiredMessage("address");
    let req_email   = await requiredMessage("email");
    let req_city    = await requiredMessage("city");
    let req_country = await requiredMessage("country");
    let req_note    = await requiredMessage("note");
    let req_zip     = await requiredMessage("zip_code");
    let req_state   = await requiredMessage("state");
    if( req_last || req_first || req_phone || req_address || req_email || req_city || req_country || req_note || req_zip || req_state ) {
        document.getElementById("noumidia-send").disabled = false;
        return;
    }
   
    // ============================
    let order_id = getCookie("order_id");             
    let id_variant = document.getElementsByName("id");
    await Shopify.clear(); 
	//Shopify.change( parseInt(id_variant[0].value) , 1, 0 ); 
    let first_name = document.getElementById("first_name");
    if(typeof first_name !== null && first_name !== null ) {
        first_name = first_name.value;
    } else {
        first_name = "";
    }
    
    const ph = document.getElementById("phone");
    if(typeof ph != null && ph !== null ) {
        let phone_number = ph.value;
    } else {
        ph = "";
    }

    let phone_error = document.getElementById('span-phone-error');
    if(typeof phone_error != null && phone_error !== null  ) {
        if ( !validatePhoneNumber(ph.value) ) {
            document.getElementById("noumidia-send").disabled = false;
            phone_error.style.display = 'block';
            return;
        } else {
            phone_error.style.display = 'none';
        }
    }     
    
    let laoder = document.getElementById("lds-ring");
    if(typeof laoder !== null && laoder !== null ) {
        laoder.style.display = "inline-block";
    }
    let text_span = document.getElementById("text-span");
    if(typeof text_span !== null && text_span !== null ) {
        text_span.style.display = "none";
    }
        
    let last_name = document.getElementById("last_name");
    if(typeof last_name != null && last_name !== null ) {
        last_name = last_name.value;
    } else {
        last_name = "";
    }
    
    let city = document.getElementById("city");
    if(typeof city != null && city !== null  ) {
        city = city.value;
    } else {
        city = "";
    }

    let phone_2 = document.getElementById("phone_2");
    if(typeof phone_2 != null && phone_2 !== null  ) {
        phone_2 = phone_2.value;
    } else {
        phone_2 = "";
    }

    let address = document.getElementById("address");
    if(typeof address !== null && address !== null ) {
        address = address.value;
    } else {
        address = "";
    }
    
    let email = document.getElementById("email");
    if(typeof email !== null && email !== null ) {
        email = email.value;
    } else {
        email = "";
    }
    
    let country = document.getElementById("country");
    if(typeof country !== null && country !== null ) {
        country = country.value;
    } else {
        country = "";
    }
    
    let note = document.getElementById("note");
    if(typeof note !== null && note !== null ) {
        note = note.value;
    } else {
        note = "";
    }
    
    let state = document.getElementById("state");
    if(typeof state !== null && state !== null ) {
        state = state.value;
    } else {
        state = "";
    }
    
    let zip_code = document.getElementById("zip_code");
    if(typeof zip_code !== null && zip_code !== null ) {
        zip_code = zip_code.value;
    } else {
        zip_code = "";
    }

    let type_qty = document.getElementById("sale-fast");
    if(typeof type_qty !== null  && type_qty !== null) {
        type_qty = type_qty.value;
    } else {
        type_qty = "qty";
    }

    var discount_id = 0;
    var crossel_product = document.getElementsByName('crossel-product');
    if(typeof crossel_product !== null  && crossel_product !== null) {
        for(i = 0; i < crossel_product.length; i++) {
            if(crossel_product[i].checked) {
                discount_id = crossel_product[i].value;
            }
        }
    }

    var rate_id = 0;
    var shipping_product = document.getElementsByName('shipping-product');
    if(typeof shipping_product !== null  && shipping_product !== null) {
        for(i = 0; i < shipping_product.length; i++) {
            if(shipping_product[i].checked) {
                rate_id = shipping_product[i].value;
            }
        }
    }
    
    let qtyVal = 1;
    if( discount_id == 0 ) {
        let qty = document.getElementById("fast-product-qty");
        if(typeof qty != null && qty !== null  ) {
            qtyVal = qty.value;
        }
    }

    await Shopify.addItemFrom( id_variant[0].value , 1, 0);
    let items_cart      = await getProductInCart(id_variant[0].value);
    var param_prod_id   = items_cart['product_id'];
    var param_price     = items_cart['price']/100;
    var items = [
        {
            product_id:         items_cart['product_id'],
            variant_id:         items_cart['variant_id'],
            price:              items_cart['price']/100,
            product_title:      items_cart['product_title'],
            product_sku:        items_cart['sku'],
            variant_title:      items_cart['variant_title'],
            quantity:           items_cart['quantity']?items_cart['quantity']:1,
        }
    ];

    var msg_error = document.getElementById("error-message-cod-popup");

    var params = 
        "last_name=" + last_name + 
        "&first_name=" + first_name + 
        "&phone=" + ph.value + 
        "&phone_2=" + phone_2 + 
        "&city=" + city + 
        "&email=" + email + 
        "&country=" + country + 
        "&items=" + JSON.stringify(items) +
        "&note=" + note + 
        "&state=" + state + 
        "&zip_code=" + zip_code + 
        "&address=" + address + 
        "&order_id=" + order_id +
        "&shop=" + Shopify.shop +
        "&currency=" + Shopify.currency.active+
        "&type_qty=" + type_qty+
        "&discount_id=" + discount_id+
        "&rate_id=" + rate_id
    ;
    return new Promise(resolve => {
        var xhrOr = new XMLHttpRequest();
        xhrOr.open('POST', 'https://fast.crodweb.com/api/create', true);
        xhrOr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrOr.onreadystatechange = async function () {
            if (xhrOr.readyState == 4 && xhrOr.status == 200) {
                let res = "["+xhrOr.response+"]";
                res = JSON.parse(res);
                
                (typeof ga === "function") ? ga('send', {
                    hitType: 'event',
                    eventCategory: 'Products',
                    eventAction: param_prod_id,
                    eventLabel: param_price
                }) : null;

                (typeof fbq === "function") ? fbq('track', 'Purchase', {
                    currency: Shopify.currency.active,
                    value: param_price
                },{eventID:new Date().getTime()}) : null;

                (typeof snaptr === "function") ? snaptr('track', 'PURCHASE', {
                    'currency': Shopify.currency.active,
                    'price': param_price,
                    'item_category': '',
                    'item_ids': ''
                }) : null;

                if (res[0].status == 0) {
                    msg_error.innerText = 'Your order is then failed, Please try again';
                    msg_error.style.display = 'block';
                } else {
                    await Shopify.clear(); 
                    setCookie("order_id", null, 1);
                    if( res[0].url != null && res[0].url != false ) {
                        if( res[0].type != null && res[0].type == "page" ) {
                            let paramas_order = '?price='+ param_price +'&currency='+Shopify.currency.active+'&item_category='+ param_prod_id;
                            return resolve(window.location.replace(res[0].url));   
                        } else {
                            return resolve(window.location.replace(res[0].url));   
                        }
                    } else {
                        msg_error.innerText = 'Your order is then successfully';
                        msg_error.classList.add("sucess-order");

                        let form_fast = document.getElementById("form-fast-input");
                        if(typeof form_fast !== null  && form_fast !== null) {
                            form_fast.style.display = 'none';
                        }

                        let noumidia_save = document.getElementById("noumidia-send");
                        if(typeof noumidia_save !== null  && noumidia_save !== null) {
                            noumidia_save.style.display = 'none';
                        }
                    }
                }
                document.getElementById("noumidia-save").disabled = false;
            }
        }
        xhrOr.send(params);
    });
}
// Check Radio button crossel
function checkRadio(id) {
    let discount = document.getElementById("discount-"+id);
    if(typeof discount !== null  && discount !== null) {
        let type_discount = discount.getAttribute('data-type');
        let valeur_discount = discount.getAttribute('data-valeur');
        let qty_discount = discount.getAttribute('data-qty');
        let fast_price = document.getElementById("fast-price");
        if(typeof fast_price !== null  && fast_price !== null) {
            let price = fast_price.getAttribute('data-price');
            let product_price = fast_price.getAttribute('data-price');
            if( type_discount == 1 ) {
                let discount_price_attr = document.getElementById("discount-fast-price");
                let discount_price_div = document.getElementById("discount_price");
                if(valeur_discount!=0) {
                    var price_disc = price*(valeur_discount/100);
                    price = (price - price_disc)*qty_discount;
                    if(typeof discount_price_attr !== null  && discount_price_attr !== null) {
                        discount_price_attr.innerHTML = "-" + ((parseFloat(price_disc).toFixed(2))*qty_discount).toFixed(2) +" "+Shopify.currency.active;
                        discount_price_attr.setAttribute('data-price' , price_disc); 
                        discount_price_attr.setAttribute('data-currency' , Shopify.currency.active); 
                        if(typeof discount_price_div !== null  && discount_price_div !== null) {
                            discount_price_div.classList.remove("fast-none");
                        }
                    }
                } else {
                    if(typeof discount_price_div !== null  && discount_price_div !== null) {
                        discount_price_div.classList.add("fast-none");
                    }
                }
            } else if(type_discount == 2) {
                var price_disc = valeur_discount;
                price = ((price*qty_discount) - price_disc);
                let discount_price_attr = document.getElementById("discount-fast-price");
                let discount_price_div = document.getElementById("discount_price");
                if(typeof discount_price_attr !== null  && discount_price_attr !== null) {
                    discount_price_attr.innerHTML = "-" + ((parseFloat(price_disc).toFixed(2))) +" "+Shopify.currency.active;
                    discount_price_attr.setAttribute('data-price' , price_disc); 
                    discount_price_attr.setAttribute('data-currency' , Shopify.currency.active); 
                    if(typeof discount_price_div !== null  && discount_price_div !== null) {
                        discount_price_div.classList.remove("fast-none");
                        if( valeur_discount == 0 ) {
                            discount_price_div.classList.add("fast-none");
                        }
                    }
                }
            }
            fast_price.innerHTML = ((parseFloat(price)+parseFloat(cashOnDiliveryPrice)).toFixed(2)) +" "+Shopify.currency.active;
            
            let product_fast_price = document.getElementById("product-fast-price");
            if(typeof product_fast_price !== null  && product_fast_price !== null) {
                product_fast_price.innerHTML = (parseFloat(product_price).toFixed(2)*qty_discount).toFixed(2) +" "+Shopify.currency.active;
            }

        }

    } 
}
// Check Radio button crossel
function checkRadioShipping(id) {
    let shipping = document.getElementById("shipping-"+id);
    if(typeof shipping !== null  && shipping !== null) {
        let price_shipping  = shipping.getAttribute('data-price');
        let fast_price      = document.getElementById("fast-price");
        if(typeof fast_price !== null  && fast_price !== null) {
            let price = fast_price.getAttribute('data-price');
            price = parseFloat(price) + parseFloat(price_shipping);
            fast_price.innerHTML = parseFloat(price).toFixed(2) +" "+Shopify.currency.active;
        }
    } 
}
// FOCUSOUT
async function customerAbandoned() {
    // CREATE ABANDOND ORDER IN CART SHOPIFY AND SEND IN APPS
    var phone = document.getElementById("phone");
    if(typeof phone != null && phone !== null  ) {
        let phone_error = document.getElementById('span-phone-error');
        if(typeof phone_error != null && phone_error !== null  ) {
            if (!validatePhoneNumber(phone.value)) {
                phone_error.style.display = 'block';
                return;
            }
            phone_error.style.display = 'none';
        }
        
        let id_variant = document.getElementsByName("id");
        // Shopify.clear();
        Shopify.addItemFrom(id_variant[0].value, 1, 0);
        let items_cart = await getProductInCart(id_variant[0].value);
        var xhrAb = new XMLHttpRequest();

        let first_name = document.getElementById("first_name");
        if(typeof first_name !== null  && first_name !== null  ) {
            first_name = first_name.value;
        }

        let last_name = document.getElementById("last_name");
        if(typeof last_name != null && last_name !== null  ) {
            last_name = last_name.value;
        }

        var items = [
            {
                product_id: items_cart['product_id'],
                variant_id: items_cart['variant_id'],
                price: items_cart['price'],
                variant_title: items_cart['variant_title'],
                quantity: items_cart['quantity']?items_cart['quantity']:1,
            }
        ];
    
        var params =
            "product_id=" + items_cart['product_id'] +
            "&variant_id=" + items_cart['variant_id'] +
            "&price=" + items_cart['price'] +
            "&variant_title=" + items_cart['variant_title'] +
            "&items=" + JSON.stringify(items) +
            "&first_name=" + first_name +
            "&last_name=" + last_name +
            "&phone=" + phone.value +
            "&shop=" + Shopify.shop +
            "&currency=" + Shopify.currency.active
        ;
    
        xhrAb.open('POST', 'https://fast.crodweb.com/api/customer', true);
        xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhrAb.onreadystatechange = async function () {
            if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                let res = "["+xhrAb.response+"]";
                res = JSON.parse(res);
                if (res[0].status == 0) {
                    msg_error.innerText = 'operation was refused';
                    msg_error.style.display = 'block';
                } else {
                    await Shopify.clear(); 
                    setCookie("order_id", null, 1);
                    if( res[0].url != null ) {
                        return resolve(window.location.replace(res[0].url));   
                    }
                }
                document.getElementById("noumidia-save").disabled = false;
            }
        }
        xhrAb.send(params);
    }
}
function movaToFast() {
    var form_fast_move = document.getElementById("noumidia-save");
    if(typeof form_fast_move != null && form_fast_move !== null  ) {
        form_fast_move.scrollIntoView({
            block: "start",
            behavior: "smooth"
        });
        openPopup();
    }
}
// **************VERSION*****************
// console.log('SCRIPT NEWS 1.1.1')